module.exports = __webpack_public_path__ + "img/snow_cave.870baa2a.jpg";